// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-container {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;

  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

.modal-content {
  width: 312px;
  overflow-wrap: break-word;
  min-height: 256px;
  max-height: 700px;
  /* height: 452px; */
  background-color: white;
  padding: 20px;
  margin: 0px;
  border-radius: 8px;
  /* text-align: center; */
  position: relative;
}

.image {
  width: 100px;
  height: 100px;
  position: absolute;
  top: -0;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  z-index: 1;
}

/* Success Modal CSS */
#modal-title {
  font-size: 24px;
  margin-top: 71px;
  text-align: center;
}

#modal-btn {
  margin: 32px 0px 0px 0px;
  text-transform: none;
}

#modal-message {
  margin-top: 71px;
  text-align: center;
}

#modal-sub-message {
  margin-top: 24px;
  color: #646464;
  font-weight: 500;
  text-align: center;
}

#modal-recipients {
  overflow: hidden;
}
#modal-recipients-headng {
  color: #8e8e8e;
  margin: 18px 0px 16px 0px;
}

#modal-recipient-name {
  margin: 0px;
}

#modal-recipient-email {
  color: #8e8e8e;
  margin: 0px 0px 16px 0px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Common/Modal/SuccessModal/SuccessModal.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;;EAEb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B","sourcesContent":[".modal-container {\n  background-color: rgba(0, 0, 0, 0.5);\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.modal-content {\n  width: 312px;\n  overflow-wrap: break-word;\n  min-height: 256px;\n  max-height: 700px;\n  /* height: 452px; */\n  background-color: white;\n  padding: 20px;\n  margin: 0px;\n  border-radius: 8px;\n  /* text-align: center; */\n  position: relative;\n}\n\n.image {\n  width: 100px;\n  height: 100px;\n  position: absolute;\n  top: -0;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  overflow: hidden;\n  z-index: 1;\n}\n\n/* Success Modal CSS */\n#modal-title {\n  font-size: 24px;\n  margin-top: 71px;\n  text-align: center;\n}\n\n#modal-btn {\n  margin: 32px 0px 0px 0px;\n  text-transform: none;\n}\n\n#modal-message {\n  margin-top: 71px;\n  text-align: center;\n}\n\n#modal-sub-message {\n  margin-top: 24px;\n  color: #646464;\n  font-weight: 500;\n  text-align: center;\n}\n\n#modal-recipients {\n  overflow: hidden;\n}\n#modal-recipients-headng {\n  color: #8e8e8e;\n  margin: 18px 0px 16px 0px;\n}\n\n#modal-recipient-name {\n  margin: 0px;\n}\n\n#modal-recipient-email {\n  color: #8e8e8e;\n  margin: 0px 0px 16px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
